import './CustomerReview.scss';
import { AiFillStar } from "react-icons/ai";
import { ImQuotesLeft } from "react-icons/im";
import React, { useEffect, useState } from 'react';

function CustomerReview(props: any) {

  const [dataofReview, setdataofReview] = useState<any>([])

  useEffect(() => {
    if (props.ReviewPage == 1) {
      setdataofReview(review1)
    } else if (props.ReviewPage == 2) {
      setdataofReview(review2)
    } else if (props.ReviewPage == 3) {
      setdataofReview(review3)
    }

  }, []);

  let review1 = [
    {
      name: "saisthabanu",
      detail: "Awesome!! One of the best app for women there are variety of clothing brands which has good and trendy collections of clothes. Best spot to sell your clothes that are in good condition but we don’t use it anymore for various reasons… It’s really a good space for women, lot of  things to learn and also share our thoughts. Just loving it"
    },
    {
      name: "Grishma Naik",
      detail: "Best app to shop famous brands at low price and great opportunity to sell your product. Amazing discounts and offers available eazy to use Highly recommended"
    },
    {
      name: "Zoya Shaikh",
      detail: "Its a great app .Now branded products are also affordable through dis app and all products are awesome."
    },

  ]
  let review2 = [
    {
      name: "jenny jmer",
      detail: "Great app to sell items. Trusted app. I'm glad there is an app like that. Thank you for this innovative idea. Great help"
    },
    {
      name: "nicelife",
      detail: "I really love this app! It makes me want to sell all my pre-loved at home. It’s very easy to manage and sell your things in just few clicks! 100% recommended!"
    },
    {
      name: "NSar S",
      detail: "Love the app! Great initiative."
    },

  ]
  let review3 = [
    {
      name: "meme queen",
      detail: "Now this is a wonderful app it allows you to engage with people around you. You can find your interests and get knowledge about fashion and lifestyle. Totally loving it."
    },
    {
      name: "saisthabanu",
      detail: "Awesome!! One of the best app for women… there are variety of clothing brands which has good and trendy collections of clothes. Best spot to sell your clothes that are in good condition but we don’t use  it anymore for various reasons… It’s really a good space for women, lot of things to learn and also share our thoughts. Just loving it!"
    },
    {
      name: "Ash_indxb",
      detail: "Amazing app! I actually love this app. It’s very easy to sell and buy preloved items at very affordable price. "
    },

  ]

  return (
    <div className='   flex-row display-flex '  >
      {dataofReview.map((data: any) =>
        <div key={data.id} className="col-md cm-1rem bg-light cp-1rem border-radius" >
          <div className=" " style={{ height: '70%' }}>
            <div>
              <ImQuotesLeft className="" color="lightgray" size="28" />
            </div>
            <div>
              <p className='secHeading ' >{data.name}</p>
            </div>
            <div>
              <p className="max-lines  pText" >{data.detail}</p>
            </div>
          </div>
          <div className="" style={{ height: '30%' }} >
            <div style={{ flexDirection: 'column-reverse' }}>
              <span className="fa fa-star checked"></span>
              <span className=" checked"><AiFillStar size="22" /></span>
              <span className="fa fa-star checked" ><AiFillStar size="22" /></span>
              <span className="fa fa-star checked" ><AiFillStar size="22" /></span>
              <span className="fa fa-star checked" ><AiFillStar size="22" /></span>
              <span className="fa fa-star checked" ><AiFillStar size="22" /></span>
            </div>
            <label className="pText">App Store review</label>
          </div>
        </div>
      )}
    </div>
  );
}

export default CustomerReview;
